<swiper [zoom]="true" (zoomChange)="onZoomChange($event)" [config]="swiperOptions" *ngIf="!loader">
    <ng-template swiperSlide>
        <div class="swiper-zoom-container" [innerHTML]="svg | sanitizeHtml" #svgRendered></div>
    </ng-template>
</swiper>
